import React, { useEffect, useState } from "react";
import "./styles.css";

const PresetMessages = (props) => {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (props.presetTemplates.length > 0) {
      setLoader(false);
    }
  }, [props.presetTemplates]);

  return (
    <div
      className="doctor-info-root preset-section-row"
    >
    {props.children}
      <div className="justify-content-lg-center align-items-lg-center">
        <div className="row my-4">
          <div className="col mt-3">
            <h4 style={{ color: "#F969A4" }} className="pl-3">
              <b>Preset Messages</b>
            </h4>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {loader === true ? (
              <img
                src={process.env.PUBLIC_URL + "/images/loader.svg"}
                style={{ opacity: "0.15", margin: "30% 10%" }}
              />
            ) : (
                <ul className="list-group">
                  {props.presetTemplates.map((temp) => (
                    <SidebarTemplate key={temp.id} {...temp} />
                  ))}
                </ul>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

const SidebarTemplate = ({ title, message_body }) => {
  return (
    <li
      className="list-group-item preset-messages"
      style={{ background: "#f5f6f7" }}
    >
      <h5 style={{ fontSize: "1.1rem" }} className="mb-1">
        <b>{title}</b>
      </h5>
      <p>{message_body}</p>
    </li>
  );
};

export default PresetMessages;
